/** GENERATED by scripts/states/gen-bundles.ts. Do not edit. What the main chunk knows about every state before (or without) loading it. */
import type { UsState } from "../types.ts";

/** The names and public-page slugs: the state picker lists all eight before any has loaded. */
export const STATE_INDEX: Record<UsState, { name: string; slug: string }> = {
  UT: { name: "Utah", slug: "utah" },
  NV: { name: "Nevada", slug: "nevada" },
  CA: { name: "California", slug: "california" },
  NY: { name: "New York", slug: "new-york" },
  OR: { name: "Oregon", slug: "oregon" },
  FL: { name: "Florida", slug: "florida" },
  TX: { name: "Texas", slug: "texas" },
  MA: { name: "Massachusetts", slug: "massachusetts" },
};

/** Each state's law-citation pattern (basis.ts: a line citing any supported state's law is law). */
export const LAW_CITE_PATTERNS: Record<UsState, string | undefined> = {
  UT: "R392-\\d|Utah Code|Utah Admin|R710-\\d",
  NV: "NRS 580\\.|NRS 618\\.|NAC 446|SNHD 2023 Food Regulations|Washoe County food regulations",
  CA: "HSC 1\\d{5}|Health and Safety Code|8 CCR|27 CCR|Labor Code 6\\d{3}|CalCode",
  NY: "NYCRR 14-|10 NYCRR|Public Health Law|NYC Health Code|RCNY|PHL 1",
  OR: "OAR 333-|ORS 624|ORS 616|ORS 433|ORS 471|MCC 21",
  FL: "Fla\\. Stat\\.|61C-\\d|F\\.A\\.C\\.",
  TX: "TFER|25 TAC 228|HSC 43\\d|Health and Safety Code",
  MA: "105 CMR 590|105 CMR 605|M\\.G\\.L\\.|c\\.111 \\u00A7|c\\.140 \\u00A76B|c\\.94 \\u00A7305D",
};
